import useFF from 'common/hooks/settings/useFF';
import useTeamUsers from './useTeamUsers';
import useTeamContributors from './useTeamContributors';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';

const useTeamMembers = ({ team }) => {
  const newUserManagementEnabled = useFF(
    FEATURE_FLAGS_NAMES.newUserManagementEnabled
  );

  const teamUsersHook = useTeamUsers({
    team,
    enabled: newUserManagementEnabled
  });
  const teamContributorsHook = useTeamContributors({ team });

  return newUserManagementEnabled ? teamUsersHook : teamContributorsHook;
};

export default useTeamMembers;
